$(document).ready(() => {

    const videoSelector = $('iframe');

    if(!videoSelector.length) {
        return;
    }

    //check if video is from youtube and has a youtube ID
    function youtube_parser(url){
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11)? match[7] : false;
    }

    videoSelector.each(function() {
        const url = $(this).attr('src');
        const parentWrapper = $(this).parent();
        const videoId = youtube_parser(url);

        if(videoId.length) {
            parentWrapper.append(`<div class="video__preview"><img src="https://img.youtube.com/vi/${videoId}/maxresdefault.jpg"></div>`);

            parentWrapper.find('.video__preview').click(function() {
                //hide preview image
                $(this).hide();

                // autoplay youtube video
                parentWrapper.find('iframe')[0].src += '?autoplay=1';
            });
        }
    });
});
